<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Modifier l'affaire</h2>
    <p class="page-subtitle">Mettez à jour les informations de l'affaire</p>
  </div>
  <a routerLink="/affaires" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </a>
</div>

<div class="form-container">
  <div class="card shadow-sm">
    <form [formGroup]="affaireForm" (ngSubmit)="onSubmit()" class="modern-form">
      <div class="form-section">
        <h3 class="section-title">Informations de l'affaire</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="numeroAffaire">NUMÉRO D'AFFAIRE</label>
            <input type="text" id="numeroAffaire" formControlName="numeroAffaire" class="form-control" placeholder="ex: AFF-2026-001">
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Client associé</h3>
        <div class="form-row">
          <div class="form-group col">
            <label>CLIENT</label>
            <div class="dropdown-select" (click)="$event.stopPropagation()">
              <button type="button" class="select-btn" (click)="toggleClientDropdown()">
                {{ displaySelectedClient() }}
                <mat-icon class="caret" aria-hidden="true">expand_more</mat-icon>
              </button>
              <div class="dropdown-panel" *ngIf="showClientDropdown()">
                <input type="text" class="dropdown-search" placeholder="Rechercher un client..." (input)="onClientSearchChange($any($event.target).value)">
                <div class="options-list">
                  @for (c of clientOptions(); track c.id) {
                    <div class="option-item" (click)="selectClient(c)">
                      <div class="option-title">{{ c.denomination }}</div>
                      <div class="option-sub">{{ c.numeroClient }} • {{ c.ville }}</div>
                    </div>
                  } @empty {
                    <div class="empty-option">Aucun client trouvé</div>
                  }
                </div>
                <button type="button" class="load-more" (click)="loadMoreClients()" [disabled]="clientPage() + 1 >= clientTotalPages() || isLoadingClients()">
                  {{ isLoadingClients() ? 'Chargement...' : (clientPage() + 1 < clientTotalPages() ? 'Charger plus' : 'Fin de liste') }}
                </button>
              </div>
            </div>
          </div>
        </div>

        @if (affaire()?.projects?.length) {
          <div class="form-row mt-4">
            <div class="form-group col">
              <label>PROJETS LIÉS</label>
              <div class="options-list static-list">
                @for (p of affaire()?.projects; track p.id) {
                  <a [routerLink]="['/projects/edit', p.id]" class="option-item project-item">
                    <div class="option-title">{{ p.name }}</div>
                    <div class="option-sub">
                      Statut :
                      <span class="status-badge"
                            [attr.data-meta]="p.metaStatus"
                            [style.background-color]="p.statusColor"
                            [style.color]="p.statusColor ? 'white' : null">
                        {{ p.statusName }}
                      </span>
                    </div>
                    <span class="view-link">Ouvrir <mat-icon aria-hidden="true" inline>arrow_forward</mat-icon></span>
                  </a>
                }
              </div>
            </div>
          </div>
        }
      </div>

      @if (errorMessage()) {
        <div class="error-banner">{{ errorMessage() }}</div>
      }

      <div class="form-actions">
        <div class="form-actions-left">
          <button type="button" class="btn btn-secondary btn-with-icon" (click)="openFilesDialog()">
            <mat-icon aria-hidden="true">folder_open</mat-icon>
            Documents ({{ affaire()?.files?.length || 0 }})
          </button>
          @if (!isArchived()) {
            <button type="button" (click)="onDeleteClick()" class="btn btn-danger" [disabled]="isLoading()">
              {{ canDelete() ? 'Supprimer' : 'Archiver' }}
            </button>
          }
        </div>
        <div class="form-actions-right">
          <a routerLink="/affaires" class="btn btn-outline">Annuler</a>
          <button type="submit" [disabled]="affaireForm.invalid || isLoading()" class="btn btn-primary">
            {{ isLoading() ? 'Mise à jour...' : 'Enregistrer' }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Boîte de dialogue des fichiers -->
@if (showFilesDialog()) {
  <app-affaire-files-dialog
    [affaire]="affaire()"
    (close)="closeFilesDialog()"
    (refresh)="loadAffaire()">
  </app-affaire-files-dialog>
}

<app-confirm-dialog
  *ngIf="showDeleteModal()"
  [title]="canDelete() ? 'Supprimer l\'affaire' : 'Archiver l\'affaire'"
  [message]="canDelete()
    ? 'Êtes-vous sûr de vouloir supprimer définitivement l\'affaire ' + (affaire()?.numeroAffaire || '') + ' ?'
    : 'Cette affaire est liée à des projets et ne peut pas être supprimée. Voulez-vous l\'archiver à la place ?'"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>
